export enum MobileBankPaymentActionTypeEnum {
  CANCELLED = 'CANCELLED',
  AUTHORIZED = 'AUTHORIZED',
  REDIRECT = 'REDIRECT'
}
